// extracted by mini-css-extract-plugin
export var currencyInput = "_kw-1";
export var currencySymbol = "_kw-0";